<div class="items">
        <app-pbi-visual-container [params]="params" [embedData]="embedData" [main_data]="PowerBIData" [catchmentCount]="catchmentCount"></app-pbi-visual-container>
</div>